// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top_bar {
    display: flex;
    width: 100%;
    height: 90px;
    padding: 15px 30px;
    gap: 30px;
    opacity: 1;
    z-index: 9;
    justify-content: space-between;
    align-items: center;
}

.search-container {
    position: relative;
    display: flex;
    gap: 6px;
    flex-grow: 1;
    max-width: 100%;
}

.search-input {
    width: 100%;
    max-width: 100%;
    height: 45px;
    padding: 1.5px 24px 1.5px 36px;
    border-radius: 12px;
    font-family: Lexend, sans-serif;
    font-size: 13.5px;
    font-weight: 400;
    line-height: 16.88px;
    text-align: left;
    color: #737791;
    background-color: rgb(243, 244, 246);
    box-sizing: border-box;
}

.search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #aaa;
    width: 24px;
    height: 24px;
    padding: 3px;
}

.profile {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 13px;
}

.profile-text,
.profile-name {
    font-family: Lexend, sans-serif;
    text-align: left;
    color: #1B9075;
}

.profile-text {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2;
}

.profile-name {
    font-size: 40px;
    font-weight: 700;
    line-height: 1.2;
}

/* media queries responsive styles  */
@media (max-width: 768px) {
    .top_bar {
        /* flex-direction: column; */
        height: auto;
        padding: 10px;
    }

    .search-container {
        width: auto;
    }

    .search-input {
        max-width: auto;
    }

    .profile {
        /* flex-direction: column; */
        width: auto;
    }

    .profile-text,
    .profile-name {
        font-size: 1rem;
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,+BAA+B;IAC/B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI;QACI,4BAA4B;QAC5B,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,4BAA4B;QAC5B,WAAW;IACf;;IAEA;;QAEI,eAAe;QACf,kBAAkB;IACtB;AACJ","sourcesContent":[".top_bar {\n    display: flex;\n    width: 100%;\n    height: 90px;\n    padding: 15px 30px;\n    gap: 30px;\n    opacity: 1;\n    z-index: 9;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.search-container {\n    position: relative;\n    display: flex;\n    gap: 6px;\n    flex-grow: 1;\n    max-width: 100%;\n}\n\n.search-input {\n    width: 100%;\n    max-width: 100%;\n    height: 45px;\n    padding: 1.5px 24px 1.5px 36px;\n    border-radius: 12px;\n    font-family: Lexend, sans-serif;\n    font-size: 13.5px;\n    font-weight: 400;\n    line-height: 16.88px;\n    text-align: left;\n    color: #737791;\n    background-color: rgb(243, 244, 246);\n    box-sizing: border-box;\n}\n\n.search-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 16px;\n    color: #aaa;\n    width: 24px;\n    height: 24px;\n    padding: 3px;\n}\n\n.profile {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 13px;\n}\n\n.profile-text,\n.profile-name {\n    font-family: Lexend, sans-serif;\n    text-align: left;\n    color: #1B9075;\n}\n\n.profile-text {\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n.profile-name {\n    font-size: 40px;\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n/* media queries responsive styles  */\n@media (max-width: 768px) {\n    .top_bar {\n        /* flex-direction: column; */\n        height: auto;\n        padding: 10px;\n    }\n\n    .search-container {\n        width: auto;\n    }\n\n    .search-input {\n        max-width: auto;\n    }\n\n    .profile {\n        /* flex-direction: column; */\n        width: auto;\n    }\n\n    .profile-text,\n    .profile-name {\n        font-size: 1rem;\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
